import React from 'react'

import logoHyundai from './../../UI/Loading/logo_hyundai.svg'
import logoDesarrollo from './../../UI/Loading/logo_desarrollo.svg'
import bg from './../../UI/Loading/bg.webp'



interface Props {
  handleOpenCarSlider: () => void,
}

interface State {
  currentLoadingPercentage: number
}

class LoadingScreen extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      currentLoadingPercentage: 0
    }
  }

  componentDidMount(): void {
    const loader = setInterval(() => {
      if(this.state.currentLoadingPercentage !== 100){
        this.setState({
          currentLoadingPercentage: this.state.currentLoadingPercentage + 1
        })
      }
      else{
        clearInterval(loader)
        this.props.handleOpenCarSlider()
      }
    }, 20)
  }

  render(): React.ReactNode {
      return(
        <div className='loading-container'>
          <div className='loading-background-container'>
            <img src={bg} alt=''/>
          </div>
          <div className='logo-loading-container'>
            <img src={logoHyundai} alt=''/>
          </div>
          <div className='logo-loading-progress-bar-container'>
            <div 
              className='logo-loading-progress-bar-fill' 
              style={{ width: `${this.state.currentLoadingPercentage}%` }}
            />
          </div>
          <div className='logo-desarrollo-container'>
            <img src={logoDesarrollo} alt=''/>
          </div>
        </div>
      )
  }
}

export default LoadingScreen